export class PaymentMethodModel {
    paymentMethodId = 0;
    name = "";
    description = "";
}
